import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-brand.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 p-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sm:mx-auto sm:w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-10 text-center text-5xl font-extrabold" }, " Create new Password ")
], -1)
const _hoisted_4 = { class: "mt-10 sm:mx-auto sm:w-full sm:max-w-md md:max-w-3xl" }
const _hoisted_5 = { class: "bg-white p-12 shadow sm:rounded-lg" }
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "flex items-center justify-center" }
const _hoisted_9 = { class: "mt-10 text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Didn't receive a code? ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-full hr bg-gray-300" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-10" }, "Create your new password", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "newPassword",
  class: "block text-2xl font-medium text-gray-700"
}, " New Password ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmPassword",
  class: "block text-2xl mt-10 font-medium text-gray-700"
}, " Confirm Password ", -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "text-center mt-12" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Did you remember your password? ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Sign In")
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 p-7" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "sm:mx-auto sm:w-full md:max-w-lg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-10 text-center text-5xl font-extrabold" }, " Reset password ")
], -1)
const _hoisted_22 = { class: "mt-12 sm:mx-auto sm:w-full sm:max-w-md md:max-w-3xl" }
const _hoisted_23 = { class: "bg-white py-16 px-14 shadow sm:rounded-lg" }
const _hoisted_24 = { class: "space-y-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " Enter your email address you're using for your log in and will send you a password reset link. ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-2xl font-medium text-gray-700"
}, " Email address ", -1)
const _hoisted_27 = { class: "mt-2" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "text-center mt-12" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Did you remember your password? ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Sign In")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.success)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, " Please enter the verification code we sent your to " + _toDisplayString(_ctx.$route.query.email), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_otp_input, {
                    ref: "otpInput",
                    "input-classes": "otp-input",
                    separator: "-",
                    "num-inputs": 6,
                    "should-auto-focus": true,
                    "is-input-num": true,
                    onOnChange: _ctx.handleOnChange,
                    onOnComplete: _ctx.handleOnComplete
                  }, null, 8, ["onOnChange", "onOnComplete"])
                ]),
                (_ctx.v2$.code.$error)
                  ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                      key: 0,
                      "error-message": "Please enter a valid code"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("button", {
                    class: "text-success",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"]))
                  }, " Resend ")
                ]),
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  id: "newPassword",
                  name: "newPassword",
                  type: "password",
                  required: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v2$.newPassword.$model) = $event)),
                  class: "input-auth"
                }, null, 512), [
                  [_vModelText, _ctx.v2$.newPassword.$model]
                ]),
                (_ctx.v2$.newPassword.$error)
                  ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                      key: 1,
                      "error-message": "Your password must be",
                      "error-message-two": "At least 8 characters",
                      "error-message-three": "One number",
                      "error-message-four": "One Uppercase letter",
                      "error-message-five": "One Lowercase letter"
                    }))
                  : _createCommentVNode("", true),
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  id: "confirmPassword",
                  name: "confirmPassword",
                  type: "password",
                  required: "",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v2$.confirmPassword.$model) = $event)),
                  class: "input-auth"
                }, null, 512), [
                  [_vModelText, _ctx.v2$.confirmPassword.$model]
                ]),
                (_ctx.v2$.confirmPassword.$error)
                  ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                      key: 2,
                      "error-message": "Passwords must be identical."
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isError)
                  ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                      key: 3,
                      "error-message": _ctx.errorMessageConfirmPass
                    }, null, 8, ["error-message"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPasswordCode && _ctx.handleResetPasswordCode(...args)), ["prevent"])),
                  type: "submit",
                  class: _normalizeClass(["btn-main", [{ disabled: _ctx.v2$.$invalid || _ctx.isLoading }]]),
                  disabled: _ctx.v2$.$invalid || _ctx.isLoading
                }, _toDisplayString(!_ctx.isLoading ? 'Submit' : 'Processing...'), 11, _hoisted_15)
              ])
            ]),
            _createElementVNode("p", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_router_link, {
                to: "/login",
                class: "text-success"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("form", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", null, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      id: "email",
                      name: "email",
                      type: "email",
                      autocomplete: "email",
                      required: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
                      class: "input-auth"
                    }, null, 512), [
                      [_vModelText, _ctx.v$.email.$model]
                    ])
                  ])
                ]),
                (_ctx.v$.email.$error)
                  ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                      key: 0,
                      "error-message": _ctx.errorMessage
                    }, null, 8, ["error-message"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"])),
                    type: "submit",
                    class: _normalizeClass(["btn-main", [{ disabled: _ctx.v$.email.$invalid || _ctx.isLoading }]]),
                    disabled: _ctx.v$.email.$invalid || _ctx.isLoading
                  }, _toDisplayString(!_ctx.isLoading ? 'Send reset email' : 'Processing...'), 11, _hoisted_28)
                ])
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_router_link, {
              to: "/login",
              class: "text-success"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            })
          ])
        ])
      ]))
}